<template>
  <div class="order" v-cloak>
    <appheader></appheader>
    <div class="box">
      <!-- //图片 -->
      <div>
        <div @mouseenter="stopImglunbo" @mouseleave="mouseLeave">
          <magnifier :imgurl="imgurl"></magnifier>
        </div>
        <div class="banner">
          <div class="slide">
            <div
              :class="[index == 0 ? 'imgbck' : '', 'imgbox']"
              v-for="(item, index) in DataList.imgPaths"
              :key="index"
              @click="changeImg(index)"
            >
              <img :src="item" alt />
            </div>
          </div>
        </div>
      </div>
      <!-- 单独款可选属性 -->
      <div
        v-if="statusFlaf"
        class="box_goumai"
        v-loading="filterCoverShow"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="productNameClass">
          {{ DataList.category }}&nbsp;&nbsp;&nbsp;{{
            DataList.broadHeading
          }}&nbsp;&nbsp;&nbsp;{{ DataList.texture }}
        </div>
        <div class="styleNumberClass" style="margin-bottom: 20px;">
          {{ DataList.styleNumber }}
        </div>
        <!-- 可选计价方式 -->
        <div
          class="order_style"
          v-if="
            DataList.normal.pricingMannerpricingManner &&
              DataList.normal.pricingManner.length > 0
          "
        >
          <div class="order_style_title">
            计价方式：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.pricingManner" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.pricingManner"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="
            DataList.normal.pricingManner &&
              DataList.normal.pricingManner.length > 0
          "
        ></el-divider>
        <!-- 可选金重 -->
        <div
          class="order_style"
          v-if="
            DataList.normal.goldWeightRange &&
              DataList.normal.goldWeightRange.length > 0
          "
        >
          <div class="order_style_title">
            可选金重：
          </div>
          <div class="selectBorder">
            <el-select
              v-model="normal.goldWeightRange"
              filterable
              placeholder=""
            >
              <el-option
                v-for="(item, idx) in DataList.normal.goldWeightRange"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="
            DataList.normal.goldWeightRange &&
              DataList.normal.goldWeightRange.length > 0
          "
        ></el-divider>
        <!-- 可选价格范围 -->
        <div
          class="order_style"
          v-if="
            DataList.normal.priceRange && DataList.normal.priceRange.length > 0
          "
        >
          <div class="order_style_title">
            价格范围：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.priceRange" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.priceRange"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="
            DataList.normal.priceRange && DataList.normal.priceRange.length > 0
          "
        ></el-divider>
        <!-- 可选尺寸 -->
        <div
          class="order_style"
          v-if="DataList.normal.size && DataList.normal.size.length > 0"
        >
          <div class="order_style_title">
            可选尺寸：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.size" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.size"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="DataList.normal.size && DataList.normal.size.length > 0"
        ></el-divider>
        <!-- 可选扣子 -->
        <div
          class="order_style"
          v-if="DataList.normal.button && DataList.normal.button.length > 0"
        >
          <div class="order_style_title">
            可选扣子：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.button" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.button"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="DataList.normal.button && DataList.normal.button.length > 0"
        ></el-divider>
        <!-- 可选是否可调节 -->
        <div
          class="order_style"
          v-if="
            DataList.normal.adjustable && DataList.normal.adjustable.length > 0
          "
        >
          <div class="order_style_title">
            是否可调节：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.adjustable" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.adjustable"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="
            DataList.normal.adjustable && DataList.normal.adjustable.length > 0
          "
        ></el-divider>
        <!-- 可选材质 -->
        <div
          class="order_style"
          v-if="DataList.normal.texture && DataList.normal.texture.length > 0"
        >
          <div class="order_style_title">
            可选材质：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.texture" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.texture"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="DataList.normal.texture && DataList.normal.texture.length > 0"
        ></el-divider>
        <!-- 可选分色 -->
        <div
          class="order_style"
          v-if="
            DataList.normal.colorSeparation &&
              DataList.normal.colorSeparation.length > 0
          "
        >
          <div class="order_style_title">
            可选分色：
          </div>
          <div class="selectBorder">
            <el-select
              v-model="normal.colorSeparation"
              filterable
              placeholder=""
            >
              <el-option
                v-for="(item, idx) in DataList.normal.colorSeparation"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="
            DataList.normal.colorSeparation &&
              DataList.normal.colorSeparation.length > 0
          "
        ></el-divider>
        <!-- 主石大小 -->
        <div
          class="order_style"
          v-if="
            DataList.normal.mainStoneSize &&
              DataList.normal.mainStoneSize.length > 0
          "
        >
          <div class="order_style_title">
            主石大小：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.mainStoneSize" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.mainStoneSize"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="
            DataList.normal.mainStoneSize &&
              DataList.normal.mainStoneSize.length > 0
          "
        ></el-divider>
        <!-- 净度 -->
        <div
          class="order_style"
          v-if="DataList.normal.clarity && DataList.normal.clarity.length > 0"
        >
          <div class="order_style_title">
            净度：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.clarity" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.clarity"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="DataList.normal.clarity && DataList.normal.clarity.length > 0"
        ></el-divider>
        <!-- 色度 -->
        <div
          class="order_style"
          v-if="DataList.normal.colour && DataList.normal.colour.length > 0"
        >
          <div class="order_style_title">
            色度：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.colour" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.colour"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="DataList.normal.colour && DataList.normal.colour.length > 0"
        ></el-divider>
        <!-- 手寸 -->
        <div
          class="order_style"
          v-if="DataList.normal.ringSize && DataList.normal.ringSize.length > 0"
        >
          <div class="order_style_title">
            手寸：
          </div>
          <div class="selectBorder">
            <el-select v-model="normal.ringSize" filterable placeholder="">
              <el-option
                v-for="(item, idx) in DataList.normal.ringSize"
                :key="idx"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <el-divider
          v-if="DataList.normal.ringSize && DataList.normal.ringSize.length > 0"
        ></el-divider>
        <!-- 工费 -->
        <div class="order_style" v-if="DataList.normal.laborExpenses">
          <div class="order_style_title">
            工费：
          </div>
          <div class="selectBorder">
            <span style="margin-right: 30px;color: #ec9368;font-size: 18px;">{{
              DataList.normal.laborExpenses
            }}</span>
          </div>
        </div>
        <el-divider v-if="DataList.normal.laborExpenses"></el-divider>
        <!-- 下单周期 -->
        <div class="order_style" v-if="DataList.orderCycle">
          <div class="order_style_title">
            下单周期：
          </div>
          <div class="selectBorder">
            <span style="margin-right: 30px;color: #ec9368;font-size: 18px;">{{
              DataList.orderCycle
            }}</span>
          </div>
        </div>
        <el-divider v-if="DataList.orderCycle"></el-divider>
        <!-- 下单件数 -->
        <div style="display:flex;align-items: center;">
          <div class="order_style_title">
            下单件数：
          </div>
          <div class="numberClass">
            <el-input-number
              size="medium"
              v-model="normal.quantity"
              :min="theSpot"
              :max="999"
              @change="numberChange('单独款')"
              label="描述文字"
            ></el-input-number>
            <div style="text-align: center;">
              (已选现货<span
                style="color: rgb(236, 147, 104);margin: 0px 5px;"
                >{{ theSpot }}</span
              >件，定制<span
                style="color: rgb(236, 147, 104);margin: 0px 5px;"
                >{{ customNum }}</span
              >件)
            </div>
          </div>
          <div style="margin-left: 20px;">
            库存<span style="color: #CB4E51;margin: 0px 5px;">{{ total }}</span
            >件
          </div>
        </div>
        <el-divider></el-divider>
        <div class="remarksClass" style="display: flex;align-items: center;">
          <div class="remarksClass_title">备注：</div>
          <div class="remarksClass_text">
            {{ normal.remark }}
          </div>
        </div>
      </div>
      <!-- 情侣款 -->
      <div
        v-if="!statusFlaf"
        class="box_goumai"
        v-loading="filterCoverShow"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="productNameClass">
          {{ DataList.category }}&nbsp;&nbsp;&nbsp;{{
            DataList.broadHeading
          }}&nbsp;&nbsp;&nbsp;{{ DataList.texture }}
        </div>
        <div class="styleNumberClass" style="margin-bottom: 20px;">
          {{ DataList.styleNumber }}
        </div>
        <div class="loversBox">
          <div class="loversBoxChild">
            <div class="loversBoxChild_title">参数信息</div>
            <div
              class="femaleClass"
              @click="nvsubmitshopcart"
              style="cursor: pointer;"
            >
              女戒
              <img v-if="nvSelected" src="../Img/weixuanzhong.png" alt />
              <img v-if="!nvSelected" src="../Img/xuanzhong.png" alt />
            </div>
            <div
              class="maleClass"
              @click="nansubmitshopcart"
              style="cursor: pointer;"
            >
              男戒 <img v-if="nanSelected" src="../Img/weixuanzhong.png" alt />
              <img v-if="!nanSelected" src="../Img/xuanzhong.png" alt />
            </div>
          </div>
          <!-- 计价方式 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.pricingManner &&
                DataList.lady.pricingManner.length > 0
            "
          >
            <div class="loversBoxChild_title">计价方式</div>
            <div class="femaleClass">
              <el-select v-model="lady.pricingManner" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="(item, idx) in DataList.lady.pricingManner"
                    :key="idx"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.pricingManner" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="(item, idx) in DataList.gent.pricingManner"
                    :key="idx"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 可选金重 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.goldWeightRange &&
                DataList.lady.goldWeightRange.length > 0
            "
          >
            <div class="loversBoxChild_title">可选金重</div>
            <div class="femaleClass">
              <el-select
                v-model="lady.goldWeightRange"
                clearable
                placeholder=""
              >
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.goldWeightRange"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select
                v-model="gent.goldWeightRange"
                clearable
                placeholder=""
              >
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.goldWeightRange"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 价格范围 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.priceRange &&
                DataList.lady.priceRange.length > 0
            "
          >
            <div class="loversBoxChild_title">价格范围</div>
            <div class="femaleClass">
              <el-select v-model="lady.priceRange" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.priceRange"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.priceRange" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.priceRange"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 可选尺寸 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.size &&
                DataList.lady.size.length > 0
            "
          >
            <div class="loversBoxChild_title">可选尺寸</div>
            <div class="femaleClass">
              <el-select v-model="lady.size" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.size"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.size" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.size"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 可选扣子 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.button &&
                DataList.lady.button.length > 0
            "
          >
            <div class="loversBoxChild_title">可选扣子</div>
            <div class="femaleClass">
              <el-select v-model="lady.button" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.button"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.button" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.button"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 是否可调节 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.adjustable &&
                DataList.lady.adjustable.length > 0
            "
          >
            <div class="loversBoxChild_title">是否可调节</div>
            <div class="femaleClass">
              <el-select v-model="lady.adjustable" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.adjustable"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.adjustable" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.adjustable"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 可选材质 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.texture &&
                DataList.lady.texture.length > 0
            "
          >
            <div class="loversBoxChild_title">可选材质</div>
            <div class="femaleClass">
              <el-select v-model="lady.texture" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.texture"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.texture" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.texture"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 可选分色 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.colorSeparation &&
                DataList.lady.colorSeparation.length > 0
            "
          >
            <div class="loversBoxChild_title">可选分色</div>
            <div class="femaleClass">
              <el-select
                v-model="lady.colorSeparation"
                clearable
                placeholder=""
              >
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.colorSeparation"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select
                v-model="gent.colorSeparation"
                clearable
                placeholder=""
              >
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.colorSeparation"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 主石大小 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.mainStoneSize &&
                DataList.lady.mainStoneSize.length > 0
            "
          >
            <div class="loversBoxChild_title">主石大小</div>
            <div class="femaleClass">
              <el-select v-model="lady.mainStoneSize" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.mainStoneSize"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.mainStoneSize" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.mainStoneSize"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 净度 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.clarity &&
                DataList.lady.clarity.length > 0
            "
          >
            <div class="loversBoxChild_title">净度</div>
            <div class="femaleClass">
              <el-select v-model="lady.clarity" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.clarity"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.clarity" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.clarity"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 色度 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.colour &&
                DataList.lady.colour.length > 0
            "
          >
            <div class="loversBoxChild_title">色度</div>
            <div class="femaleClass">
              <el-select v-model="lady.colour" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.colour"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.colour" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.colour"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 手寸 -->
          <div
            class="loversBoxChild"
            v-if="
              DataList.lady &&
                DataList.lady.ringSize &&
                DataList.lady.ringSize.length > 0
            "
          >
            <div class="loversBoxChild_title">手寸</div>
            <div class="femaleClass">
              <el-select v-model="lady.ringSize" clearable placeholder="">
                <div v-if="DataList.lady">
                  <el-option
                    v-for="item in DataList.lady.ringSize"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
            <div class="maleClass">
              <el-select v-model="gent.ringSize" clearable placeholder="">
                <div v-if="DataList.gent">
                  <el-option
                    v-for="item in DataList.gent.ringSize"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </div>
              </el-select>
            </div>
          </div>
          <!-- 工费 -->
          <div
            class="loversBoxChild"
            v-if="DataList.gent && DataList.gent.laborExpenses"
          >
            <div class="loversBoxChild_title">工费</div>
            <div class="femaleClass">
              {{ DataList.lady.laborExpenses }}
            </div>
            <div class="maleClass">
              {{ DataList.gent.laborExpenses }}
            </div>
          </div>
          <!-- 下单周期 -->
          <div class="loversBoxChild" v-if="DataList.orderCycle">
            <div class="loversBoxChild_title">下单周期</div>
            <div class="femaleClass">
              {{ DataList.orderCycle }}
            </div>
            <div class="maleClass">
              {{ DataList.orderCycle }}
            </div>
          </div>
          <!-- 下单件数 -->
          <div class="loversBoxChild" style="line-height: 35px;">
            <div class="loversBoxChild_title">下单件数</div>
            <div class="femaleClass">
              <el-input-number
                size="small"
                :min="femaleTheSpot"
                :max="999"
                @change="numberChange('女款')"
                v-model="lady.quantity"
              ></el-input-number>
              <div style="font-size:12px">
                (已选现货<span
                  style="color: rgb(236, 147, 104);margin: 0px 5px;"
                  >{{ femaleTheSpot }}</span
                >件，定制<span
                  style="color: rgb(236, 147, 104);margin: 0px 5px;"
                  >{{ femaleCustomNum }}</span
                >件)
              </div>
              <div style="font-size:14px">
                库存<span style="color: #CB4E51;margin: 0px 5px;">{{
                  totalTwo
                }}</span
                >件
              </div>
            </div>
            <div class="maleClass">
              <el-input-number
                size="small"
                :min="maleTheSpot"
                :max="999"
                @change="numberChange('男款')"
                v-model="gent.quantity"
              ></el-input-number>
              <div style="font-size:12px">
                (已选现货<span
                  style="color: rgb(236, 147, 104);margin: 0px 5px;"
                  >{{ maleTheSpot }}</span
                >件，定制<span
                  style="color: rgb(236, 147, 104);margin: 0px 5px;"
                  >{{ maleCustomNum }}</span
                >件)
              </div>
              <div style="font-size:14px">
                库存<span style="color: #CB4E51;margin: 0px 5px;">{{
                  totalTherr
                }}</span
                >件
              </div>
            </div>
          </div>
          <!-- <div class="loversBoxChild">
            <div class="loversBoxChild_title">商品价格</div>
            <div class="femaleClass">{{ commodityPrice | moneyFilter }}</div>
            <div class="maleClass">{{ commodityPrice | moneyFilter }}</div>
          </div> -->
          <!-- 备注 -->
          <div class="loversBoxChild">
            <div class="loversBoxChild_title">备注</div>
            <div
              class="femaleClass"
              style="display: flex;align-items: center;justify-content: center;font-size: 14px;line-height: 24px;word-break: break-all;"
            >
              {{ lady.remark }}
            </div>
            <div
              class="maleClass"
              style="display: flex;align-items: center;justify-content: center;font-size: 14px;line-height: 24px;word-break: break-all;"
            >
              {{ gent.remark }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 单独款现货列表 -->
    <div
      class="soptClass"
      v-if="paragraphFlag"
      v-loading="filterCoverShow"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="soptClass_head">现货列表</div>
      <div class="context_box">
        <div class="context_head" :class="{ active: isActive }">
          <div class="context_head_textuer">材质</div>
          <div class="context_head_name">主石名称</div>
          <div class="context_head_name">主石数量</div>
          <div class="context_head_name">主石重量</div>
          <div class="context_head_OneName">辅石1名称</div>
          <div class="context_head_OneName">辅石1数量</div>
          <div class="context_head_OneName">辅石1重量</div>
          <div class="context_head_OneName">辅石2名称</div>
          <div class="context_head_OneName">辅石2数量</div>
          <div class="context_head_OneName">辅石2重量</div>
          <div class="context_head_textuer">金重</div>
          <div class="context_head_textuer">净度</div>
          <div class="context_head_textuer">色度</div>
          <div class="context_head_name">标签价格</div>
          <div class="context_head_textuer">GIA</div>
          <div class="context_head_textuer">手寸</div>
          <div class="context_head_name">是否下单</div>
        </div>
        <div
          class="infinite-list-wrapper"
          style="overflow:auto;font-size:16px;max-height:205px"
          infinite-scroll-disabled="disabled"
        >
          <ul class="infinite-list-wrapper" v-infinite-scroll="paragraphLoad">
            <li
              v-for="(item, index) in paragraphList"
              :key="index"
              class="list-item"
            >
              <div class="context_head_textuer">{{ item.texture }}</div>
              <div class="context_head_name">{{ item.mainStoneName }}</div>
              <div class="context_head_name">{{ item.mainStoneNumber }}</div>
              <div class="context_head_name">{{ item.mainStoneWeight }}</div>
              <div class="context_head_OneName">
                {{ item.assistStoneNameOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNumberOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneWeightOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNameTwo }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNumberTwo }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneWeightTwo }}
              </div>
              <div class="context_head_textuer">{{ item.goldenWeigh }}</div>
              <div class="context_head_textuer">
                {{ item.mainStoneClarity }}
              </div>
              <div class="context_head_textuer">{{ item.mainStoneColour }}</div>
              <div class="context_head_name">{{ item.labelPrice }}</div>
              <div class="context_head_textuer">{{ item.gia | giaFilter }}</div>
              <div class="context_head_textuer">{{ item.ringSize }}</div>
              <div class="context_head_name">
                <el-checkbox
                  @change="selectedSpot('单独款', item)"
                  v-model="item.switchFlag"
                ></el-checkbox>
              </div>
            </li>
          </ul>
          <p v-if="paragraphLoading" class="lodClass">加载中...</p>
          <p v-if="paragraphNoMore" class="noMore">没有更多了</p>
        </div>
      </div>
    </div>
    <!-- 情侣款女款现货列表 -->
    <div
      class="soptClass"
      v-if="femaleParagraph"
      v-loading="filterCoverShow"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="soptClass_head">女现货列表</div>
      <div class="context_box">
        <div class="context_head" :class="{ active: isActive }">
          <div class="context_head_textuer">材质</div>
          <div class="context_head_name">主石名称</div>
          <div class="context_head_name">主石数量</div>
          <div class="context_head_name">主石重量</div>
          <div class="context_head_OneName">辅石1名称</div>
          <div class="context_head_OneName">辅石1数量</div>
          <div class="context_head_OneName">辅石1重量</div>
          <div class="context_head_OneName">辅石2名称</div>
          <div class="context_head_OneName">辅石2数量</div>
          <div class="context_head_OneName">辅石2重量</div>
          <div class="context_head_textuer">金重</div>
          <div class="context_head_textuer">净度</div>
          <div class="context_head_textuer">色度</div>
          <div class="context_head_name">标签价格</div>
          <div class="context_head_textuer">GIA</div>
          <div class="context_head_textuer">手寸</div>
          <div class="context_head_name">是否下单</div>
        </div>
        <div
          class="infinite-list-wrapper"
          style="overflow:auto;font-size:16px;max-height:205px"
          infinite-scroll-disabled="femaleDisabled"
        >
          <ul
            class="infinite-list-wrapper"
            v-infinite-scroll="femalParagraphLoad"
          >
            <li
              v-for="(item, index) in femaleParagraphList"
              :key="index"
              class="list-item"
            >
              <div class="context_head_textuer">{{ item.texture }}</div>
              <div class="context_head_name">{{ item.mainStoneName }}</div>
              <div class="context_head_name">{{ item.mainStoneNumber }}</div>
              <div class="context_head_name">{{ item.mainStoneWeight }}</div>
              <div class="context_head_OneName">
                {{ item.assistStoneNameOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNumberOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneWeightOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNameTwo }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNumberTwo }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneWeightTwo }}
              </div>
              <div class="context_head_textuer">{{ item.goldenWeigh }}</div>
              <div class="context_head_textuer">
                {{ item.mainStoneClarity }}
              </div>
              <div class="context_head_textuer">{{ item.mainStoneColour }}</div>
              <div class="context_head_name">{{ item.labelPrice }}</div>
              <div class="context_head_textuer">{{ item.gia | giaFilter }}</div>
              <div class="context_head_textuer">{{ item.ringSize }}</div>
              <div class="context_head_name">
                <el-checkbox
                  @change="selectedSpot('女款', item)"
                  v-model="item.femaleSwitchFlag"
                ></el-checkbox>
              </div>
            </li>
          </ul>
          <p v-if="femaleParagraphLoading" class="lodClass">加载中...</p>
          <p v-if="femaleNoMore" class="noMore">没有更多了</p>
        </div>
      </div>
    </div>
    <!-- 情侣款男款现货列表 -->
    <div
      class="soptClass"
      v-if="maleParagraph"
      v-loading="filterCoverShowTwo"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="soptClass_head">男现货列表</div>
      <div class="context_box">
        <div class="context_head" :class="{ activeTwo: isActiveTwo }">
          <div class="context_head_textuer">材质</div>
          <div class="context_head_name">主石名称</div>
          <div class="context_head_name">主石数量</div>
          <div class="context_head_name">主石重量</div>
          <div class="context_head_OneName">辅石1名称</div>
          <div class="context_head_OneName">辅石1数量</div>
          <div class="context_head_OneName">辅石1重量</div>
          <div class="context_head_OneName">辅石2名称</div>
          <div class="context_head_OneName">辅石2数量</div>
          <div class="context_head_OneName">辅石2重量</div>
          <div class="context_head_textuer">金重</div>
          <div class="context_head_textuer">净度</div>
          <div class="context_head_textuer">色度</div>
          <div class="context_head_name">标签价格</div>
          <div class="context_head_textuer">GIA</div>
          <div class="context_head_textuer">手寸</div>
          <div class="context_head_name">是否下单</div>
        </div>
        <div
          class="infinite-list-wrapper"
          style="overflow:auto;font-size:16px;max-height:205px"
          infinite-scroll-disabled="maleDisabled"
        >
          <ul
            class="infinite-list-wrapper"
            v-infinite-scroll="malParagraphLoad"
          >
            <li
              v-for="(item, index) in maleParagraphList"
              :key="index"
              class="list-item"
            >
              <div class="context_head_textuer">{{ item.texture }}</div>
              <div class="context_head_name">{{ item.mainStoneName }}</div>
              <div class="context_head_name">{{ item.mainStoneNumber }}</div>
              <div class="context_head_name">{{ item.mainStoneWeight }}</div>
              <div class="context_head_OneName">
                {{ item.assistStoneNameOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNumberOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneWeightOne }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNameTwo }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneNumberTwo }}
              </div>
              <div class="context_head_OneName">
                {{ item.assistStoneWeightTwo }}
              </div>
              <div class="context_head_textuer">{{ item.goldenWeigh }}</div>
              <div class="context_head_textuer">
                {{ item.mainStoneClarity }}
              </div>
              <div class="context_head_textuer">{{ item.mainStoneColour }}</div>
              <div class="context_head_name">{{ item.labelPrice }}</div>
              <div class="context_head_textuer">{{ item.gia | giaFilter }}</div>
              <div class="context_head_textuer">{{ item.ringSize }}</div>
              <div class="context_head_name">
                <el-checkbox
                  @change="selectedSpot('男款', item)"
                  v-model="item.maleSwitchFlag"
                ></el-checkbox>
              </div>
            </li>
          </ul>
          <p v-if="maleParagraphLoading" class="lodClass">加载中...</p>
          <p v-if="maleNoMore" class="noMore">没有更多了</p>
        </div>
      </div>
    </div>
    <div>
      <!-- 加入购物车按钮 -->
      <div
        style="width: 572px;text-align:center;margin:auto;margin-top:56px"
        class="onebottom"
      >
        <el-button
          @click="addCart"
          style="height:68px;width: 565px;background:#EC9368;color:#fff;font-size:18px"
          >加入购物车</el-button
        >
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import Magnifier from "./moudel/magnifier";
import $ from "jquery";
import Appheader from "./moudel/Appheader";
import bottom from "./bady_bottom/bottom";

export default {
  components: {
    Magnifier,
    Appheader,
    bottom,
  },
  data() {
    return {
      // 单独款
      normal: {
        pricingManner: "", //计价方式
        goldWeightRange: "", //金重
        priceRange: "", //价格范围
        size: "", //尺寸
        button: "", //扣子
        adjustable: "", //是否可调节
        texture: "", //材质
        gender: "", //男女
        colorSeparation: "", //分色
        quantity: "", //数量
        remark: "", // 单独款备注
        mainStoneSize: "", //主石大小
        clarity: "", //净度
        colour: "", //色度
        ringSize: "", // 手寸
        barcodes: [], //现货条码
      },
      //情侣款女款
      lady: {
        pricingManner: "", //计价方式
        goldWeightRange: "", //金重
        priceRange: "", //价格范围
        size: "", //尺寸
        button: "", //扣子
        adjustable: "", //是否可调节
        texture: "", //材质
        gender: "", //男女
        colorSeparation: "", //分色
        quantity: "", //数量
        remark: "", // 女款款备注
        mainStoneSize: "", //主石大小
        clarity: "", //净度
        colour: "", //色度
        ringSize: "", // 手寸
        barcodes: [], //现货条码
      },
      //情侣款男款
      gent: {
        pricingManner: "", //计价方式
        goldWeightRange: "", //金重
        priceRange: "", //价格范围
        size: "", //尺寸
        button: "", //扣子
        adjustable: "", //是否可调节
        texture: "", //材质
        gender: "", //男女
        colorSeparation: "", //分色
        quantity: "", //数量
        remark: "", // 男款款备注
        mainStoneSize: "", //主石大小
        clarity: "", //净度
        colour: "", //色度
        ringSize: "", // 手寸
        barcodes: [], //现货条码
      },
      imgurl: "",
      index: 0, //开始轮播的值
      timer: null, //停止轮播的值
      size: 0, //图片的张数
      picHeight: 0, //图片的高度
      filterCoverShow: false,
      filterCoverShowTwo: false,
      statusFlaf: false,
      nvSelected: true,
      nanSelected: true,
      DataList: {},
      pageSize: 5,
      pageNum: 1,
      pageNumTwo: 1,
      pageNumTherr: 1,
      total: 0,
      totalTwo: 0,
      totalTherr: 0,
      paragraphList: [], //单独款现货列表
      paragraphLoading: false, //单独款
      paragraphFlag: false,
      theSpot: 0, //单独款现货件数
      customNum: 0, //单独款定制件数

      femaleParagraphList: [], //情侣款女款现货列表
      femaleParagraphLoading: false, //情侣款女款
      femaleParagraphFlag: false, //情侣款女款
      femaleParagraph: false,
      femaleTheSpot: 0, //情侣款女款现货件数
      femaleCustomNum: 0, //情侣款女款定制件数

      maleParagraphList: [], //情侣款男款现货列表
      maleParagraphLoading: false, //情侣款男款
      maleParagraphFlag: false, //情侣款男款
      maleTheSpot: 0, //情侣款男款现货件数
      maleCustomNum: 0, //情侣款男款定制件数
      maleParagraph: false,
      isActive: false,
      isActiveTwo: false,
    };
  },
  computed: {
    // 单独款
    paragraphNoMore() {
      return this.total <= this.paragraphList.length;
    },
    disabled() {
      return this.paragraphLoading || this.paragraphNoMore;
    },
    // 情侣款女款
    femaleNoMore() {
      return this.totalTwo <= this.femaleParagraphList.length;
    },
    femaleDisabled() {
      return this.femaleParagraphLoading || this.femaleNoMore;
    },
    //情侣款男款
    maleNoMore() {
      return this.totalTherr <= this.maleParagraphList.length;
    },
    maleDisabled() {
      return this.maleParagraphLoading || this.maleNoMore;
    },
  },
  mounted() {
    // 获取商品详情
    this.getSPdetale();
  },
  methods: {
    // 下单件数改变
    numberChange(item) {
      if (item == "单独款") {
        this.customNum = this.normal.quantity - this.theSpot;
      } else if (item == "女款") {
        this.femaleCustomNum = this.lady.quantity - this.femaleTheSpot;
      } else if (item == "男款") {
        this.maleCustomNum = this.gent.quantity - this.maleTheSpot;
      }
    },
    //选中现货
    selectedSpot(res, item) {
      if (res == "单独款") {
        if (item.switchFlag == true) {
          this.theSpot++;
          this.normal.barcodes.push(item.barcode);
        } else {
          this.theSpot--;
          for (let i = 0; i < this.normal.barcodes.length; i++) {
            if (this.normal.barcodes[i] == item.barcode) {
              this.normal.barcodes.splice(this.normal.barcodes[i], 1);
            }
          }
        }
        this.normal.quantity = this.theSpot + this.customNum;
      } else if (res == "女款") {
        if (item.femaleSwitchFlag == true) {
          this.femaleTheSpot++;
          this.lady.barcodes.push(item.barcode);
        } else {
          this.femaleTheSpot--;
          for (let i = 0; i < this.lady.barcodes.length; i++) {
            if (this.lady.barcodes[i] == item.barcode) {
              this.lady.barcodes.splice(this.lady.barcodes[i], 1);
            }
          }
        }
        this.lady.quantity = this.femaleTheSpot + this.femaleCustomNum;
      } else if (res == "男款") {
        if (item.maleSwitchFlag == true) {
          this.maleTheSpot++;
          this.gent.barcodes.push(item.barcode);
        } else {
          this.maleTheSpot--;
          for (let i = 0; i < this.gent.barcodes.length; i++) {
            if (this.gent.barcodes[i] == item.barcode) {
              this.gent.barcodes.splice(this.gent.barcodes[i], 1);
            }
          }
        }
        this.gent.quantity = this.maleTheSpot + this.maleCustomNum;
      }
    },
    // 单独款现货分页
    paragraphLoad() {
      if (this.filterCoverShow == false && this.paragraphNoMore == false) {
        this.pageNum++;
        this.paragraphLoading = true;
        this.spotPage();
      }
    },
    // 情侣款女款现货分页
    femalParagraphLoad() {
      if (this.filterCoverShow == false && this.femaleNoMore == false) {
        this.pageNumTwo++;
        this.femaleParagraphLoading = true;
        this.femaleSpot("女");
      }
    },
    // 情侣款男款现货分页
    malParagraphLoad() {
      if (this.filterCoverShowTwo == false && this.maleNoMore == false) {
        this.pageNumTherr++;
        this.maleParagraphLoading = true;
        this.maleSpot("男");
      }
    },
    nvsubmitshopcart() {
      if (this.nanSelected == true && this.nvSelected == true) {
        this.nvSelected = !this.nvSelected;
        this.nanSelected = !this.nanSelected;
      } else if (this.nanSelected == false && this.nvSelected == true) {
        this.nvSelected = false;
      } else if (this.nanSelected == true && this.nvSelected == false) {
        this.nvSelected = true;
        this.nanSelected = true;
      } else if (this.nanSelected == false && this.nvSelected == false) {
        this.nvSelected = true;
      }
      this.$forceUpdate();
    },
    nansubmitshopcart() {
      if (this.nvSelected == true && this.nanSelected == true) {
        this.nvSelected = !this.nvSelected;
        this.nanSelected = !this.nanSelected;
      } else if (this.nvSelected == false && this.nanSelected == false) {
        this.nanSelected = true;
      } else if (this.nvSelected == true && this.nanSelected == false) {
        this.nanSelected = true;
      } else if (this.nvSelected == false && this.nanSelected == true) {
        this.nanSelected = false;
      }
      this.$forceUpdate();
    },
    // 加入购物车
    addCart() {
      var that = this;
      var url = "/direct/shop-cart/add";
      if (this.statusFlaf == false) {
        that
          .$axios({
            url: url,
            method: "post",
            cache: false,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json",
              "T-token": JSON.parse(localStorage.getItem("userData")).token,
            },
            data: JSON.stringify({
              styleNumber: this.DataList.styleNumber,
              gent: this.gent,
              lady: this.lady,
            }),
          })
          .then((re) => {
            if (re.data.code == 200) {
              this.$confirm(re.data.msg, "提示", {
                confirmButtonText: "去购物车",
                cancelButtonText: "继续下单",
                type: "success",
              })
                .then(() => {
                  that.$router.push("/shoppingCart");
                })
                .catch(() => {});
            } else if (re.data.code == 500) {
              this.$message({
                message: re.data.msg,
                type: "error",
                duration: 1500,
              });
            }
          });
        // }
      } else {
        that
          .$axios({
            url: url,
            method: "post",
            cache: false,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json",
              "T-token": JSON.parse(localStorage.getItem("userData")).token,
            },
            data: JSON.stringify({
              styleNumber: this.DataList.styleNumber,
              normal: this.normal,
            }),
          })
          .then((re) => {
            if (re.data.code == 200) {
              this.$confirm(re.data.msg, "提示", {
                confirmButtonText: "去购物车",
                cancelButtonText: "继续下单",
                type: "success",
                duration: 0,
              })
                .then(() => {
                  that.$router.push("/shoppingCart");
                })
                .catch(() => {});
            } else if (re.data.code == 500) {
              this.$message({
                message: re.data.msg,
                type: "error",
                duration: 1500,
              });
            }
          });
      }
    },
    mouseLeave() {
      this.autoSlide(); // 图片开始再次轮播
    },
    stopImglunbo() {
      clearInterval(this.timer);
    },
    //获取商品详情
    getSPdetale() {
      var that = this;
      var item = this.$route.query.id;
      var url = `/direct/goods/info?styleNumber=${item}`;
      that
        .$axios({
          url: url,
          method: "GET",
          cache: false,
          headers: {
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
        })
        .then((re) => {
          if (re.data.code === 200) {
            if (re.data.data.normal != null) {
              this.statusFlaf = true;
              this.DataList = re.data.data;
              this.normal.remark = this.DataList.remark;
              // 默认计价方式
              if (
                this.DataList.normal.pricingManner &&
                this.DataList.normal.pricingManner.length == 1
              ) {
                this.normal.pricingManner = this.DataList.normal.pricingManner[0];
              }
              // 默认可选金重
              if (
                this.DataList.normal.goldWeightRange &&
                this.DataList.normal.goldWeightRange.length == 1
              ) {
                this.normal.goldWeightRange = this.DataList.normal.goldWeightRange[0];
              }
              //默认可选价格范围
              if (
                this.DataList.normal.priceRange &&
                this.DataList.normal.priceRange.length == 1
              ) {
                this.normal.priceRange = this.DataList.normal.priceRange[0];
              }
              //默认可选尺寸
              if (
                this.DataList.normal.size &&
                this.DataList.normal.size.length == 1
              ) {
                this.normal.size = this.DataList.normal.size[0];
              }
              //默认可选扣子
              if (
                this.DataList.normal.button &&
                this.DataList.normal.button.length == 1
              ) {
                this.normal.button = this.DataList.normal.button[0];
              }
              //默认可选是否可调节
              if (
                this.DataList.normal.adjustable &&
                this.DataList.normal.adjustable.length == 1
              ) {
                this.normal.adjustable = this.DataList.normal.adjustable[0];
              }
              //默认可选材质
              if (
                this.DataList.normal.texture &&
                this.DataList.normal.texture.length == 1
              ) {
                this.normal.texture = this.DataList.normal.texture[0];
              }
              //默认可选分色
              if (
                this.DataList.normal.colorSeparation &&
                this.DataList.normal.colorSeparation.length == 1
              ) {
                this.normal.colorSeparation = this.DataList.normal.colorSeparation[0];
              }
              //默认主石大小
              if (
                this.DataList.normal.mainStoneSize &&
                this.DataList.normal.mainStoneSize.length == 1
              ) {
                this.normal.mainStoneSize = this.DataList.normal.mainStoneSize[0];
              }
              //默认净度
              if (
                this.DataList.normal.clarity &&
                this.DataList.normal.clarity.length == 1
              ) {
                this.normal.clarity = this.DataList.normal.clarity[0];
              }
              //默认色度
              if (
                this.DataList.normal.colour &&
                this.DataList.normal.colour.length == 1
              ) {
                this.normal.colour = this.DataList.normal.colour[0];
              }
              //默认手寸
              if (
                this.DataList.normal.ringSize &&
                this.DataList.normal.ringSize.length == 1
              ) {
                this.normal.ringSize = this.DataList.normal.ringSize[0];
              }
              this.spotPage();
            } else {
              this.statusFlaf = false;
              this.DataList = re.data.data;
              this.lady.remark = this.DataList.remark;
              this.gent.remark = this.DataList.remark;
              // 默认计价方式
              if (
                this.DataList.lady.pricingManner &&
                this.DataList.lady.pricingManner.length == 1
              ) {
                this.lady.pricingManner = this.DataList.lady.pricingManner[0];
              }
              if (
                this.DataList.gent.pricingManner &&
                this.DataList.gent.pricingManner.length == 1
              ) {
                this.gent.pricingManner = this.DataList.gent.pricingManner[0];
              }
              // 默认可选金重
              if (
                this.DataList.lady.goldWeightRange &&
                this.DataList.lady.goldWeightRange.length == 1
              ) {
                this.lady.goldWeightRange = this.DataList.lady.goldWeightRange[0];
              }
              if (
                this.DataList.gent.goldWeightRange &&
                this.DataList.gent.goldWeightRange.length == 1
              ) {
                this.gent.goldWeightRange = this.DataList.gent.goldWeightRange[0];
              }
              //默认可选价格范围
              if (
                this.DataList.lady.priceRange &&
                this.DataList.lady.priceRange.length == 1
              ) {
                this.lady.priceRange = this.DataList.lady.priceRange[0];
              }
              if (
                this.DataList.gent.priceRange &&
                this.DataList.gent.priceRange.length == 1
              ) {
                this.gent.priceRange = this.DataList.gent.priceRange[0];
              }
              //默认可选尺寸
              if (
                this.DataList.lady.size &&
                this.DataList.lady.size.length == 1
              ) {
                this.lady.size = this.DataList.lady.size[0];
              }
              if (
                this.DataList.gent.size &&
                this.DataList.gent.size.length == 1
              ) {
                this.gent.size = this.DataList.gent.size[0];
              }
              //默认可选扣子
              if (
                this.DataList.lady.button &&
                this.DataList.lady.button.length == 1
              ) {
                this.lady.button = this.DataList.lady.button[0];
              }
              if (
                this.DataList.gent.button &&
                this.DataList.gent.button.length == 1
              ) {
                this.gent.button = this.DataList.gent.button[0];
              }
              //默认可选是否可调节
              if (
                this.DataList.lady.adjustable &&
                this.DataList.lady.adjustable.length == 1
              ) {
                this.lady.adjustable = this.DataList.lady.adjustable[0];
              }
              if (
                this.DataList.gent.adjustable &&
                this.DataList.gent.adjustable.length == 1
              ) {
                this.gent.adjustable = this.DataList.gent.adjustable[0];
              }
              //默认可选材质
              if (
                this.DataList.lady.texture &&
                this.DataList.lady.texture.length == 1
              ) {
                this.lady.texture = this.DataList.lady.texture[0];
              }
              if (
                this.DataList.gent.texture &&
                this.DataList.gent.texture.length == 1
              ) {
                this.gent.texture = this.DataList.gent.texture[0];
              }
              //默认可选分色
              if (
                this.DataList.lady.colorSeparation &&
                this.DataList.lady.colorSeparation.length == 1
              ) {
                this.lady.colorSeparation = this.DataList.lady.colorSeparation[0];
              }
              if (
                this.DataList.gent.colorSeparation &&
                this.DataList.gent.colorSeparation.length == 1
              ) {
                this.gent.colorSeparation = this.DataList.gent.colorSeparation[0];
              }
              //默认主石大小
              if (
                this.DataList.lady.mainStoneSize &&
                this.DataList.lady.mainStoneSize.length == 1
              ) {
                this.lady.mainStoneSize = this.DataList.lady.mainStoneSize[0];
              }
              if (
                this.DataList.gent.mainStoneSize &&
                this.DataList.gent.mainStoneSize.length == 1
              ) {
                this.gent.mainStoneSize = this.DataList.gent.mainStoneSize[0];
              }
              //默认净度
              if (
                this.DataList.lady.clarity &&
                this.DataList.lady.clarity.length == 1
              ) {
                this.lady.clarity = this.DataList.lady.clarity[0];
              }
              if (
                this.DataList.gent.clarity &&
                this.DataList.gent.clarity.length == 1
              ) {
                this.gent.clarity = this.DataList.gent.clarity[0];
              }
              //默认色度
              if (
                this.DataList.lady.colour &&
                this.DataList.lady.colour.length == 1
              ) {
                this.lady.colour = this.DataList.lady.colour[0];
              }
              if (
                this.DataList.gent.colour &&
                this.DataList.gent.colour.length == 1
              ) {
                this.gent.colour = this.DataList.gent.colour[0];
              }
              //默认手寸
              if (
                this.DataList.lady.ringSize &&
                this.DataList.lady.ringSize.length == 1
              ) {
                this.lady.ringSize = this.DataList.lady.ringSize[0];
              }
              if (
                this.DataList.gent.ringSize &&
                this.DataList.gent.ringSize.length == 1
              ) {
                this.gent.ringSize = this.DataList.gent.ringSize[0];
              }
              // 女款现货
              this.femaleSpot("女");
              //男款现货
              this.maleSpot("男");
            }
            this.imgurl = re.data.data.imgPaths[0];
            if (re.data.data.imgPaths.length > 3) {
              this.DataList.imgPaths = re.data.data.imgPaths.splice(0, 3);
            } else {
              this.DataList.imgPaths = re.data.data.imgPaths;
            }
            // DOM 渲染完毕后执行轮播事件
            this.$nextTick(function() {
              this.picHeight = $(".slide img").width(); //获取宽度度
              this.size = $(".slide").children().length; // 获取图片张数
              $(".banner").mouseover(() => {
                clearInterval(this.timer); // 停止图片轮播
              });
              $(".banner").mouseleave(() => {
                this.autoSlide(); // 图片开始再次轮播
              });
              $(".slide").mouseleave();
            });
          }
        });
    },
    // 单独款现货分页
    spotPage() {
      var that = this;
      this.filterCoverShow = true;
      var url =
        "/direct/goods/spot/paging?pageSize=" +
        that.pageSize +
        "&pageNum=" +
        that.pageNum;
      that
        .$axios({
          url: url,
          method: "POST",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            styleNumber: this.$route.query.id,
          }),
        })
        .then((res) => {
          if (res.data.code === 0) {
            for (let i = 0; i < res.data.rows.length; i++) {
              res.data.rows.switchFlag = false;
              this.paragraphList.push(res.data.rows[i]);
            }
            this.total = res.data.total;
            this.paragraphLoading = false;
            if (this.paragraphList.length > 0) {
              this.paragraphFlag = true;
            } else {
              this.paragraphFlag = false;
            }
            if (this.total > 5) {
              this.isActive = true;
            }
            this.filterCoverShow = false;
          }
        });
    },
    // 情侣款女款现货
    femaleSpot(item) {
      var that = this;
      this.filterCoverShow = true;
      var url =
        "/direct/goods/spot/paging?pageSize=" +
        that.pageSize +
        "&pageNum=" +
        that.pageNumTwo;
      that
        .$axios({
          url: url,
          method: "POST",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            styleNumber: this.$route.query.id,
            gender: item,
          }),
        })
        .then((res) => {
          if (res.data.code === 0) {
            for (let i = 0; i < res.data.rows.length; i++) {
              res.data.rows.femaleSwitchFlag = false;
              this.femaleParagraphList.push(res.data.rows[i]);
            }
            this.totalTwo = res.data.total;
            this.femaleParagraphLoading = false;
            if (this.femaleParagraphList.length > 0) {
              this.femaleParagraph = true;
            } else {
              this.femaleParagraph = false;
            }
            if (this.totalTwo > 5) {
              this.isActive = true;
            }
            this.filterCoverShow = false;
          }
        });
    },
    // 情侣款男款现货
    maleSpot(item) {
      var that = this;
      this.filterCoverShowTwo = true;
      var url =
        "/direct/goods/spot/paging?pageSize=" +
        that.pageSize +
        "&pageNum=" +
        that.pageNumTherr;
      that
        .$axios({
          url: url,
          method: "POST",
          cache: false,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/json",
            "T-token": JSON.parse(localStorage.getItem("userData")).token,
          },
          data: JSON.stringify({
            styleNumber: this.$route.query.id,
            gender: item,
          }),
        })
        .then((res) => {
          if (res.data.code === 0) {
            for (let i = 0; i < res.data.rows.length; i++) {
              res.data.rows.maleSwitchFlag = false;
              this.maleParagraphList.push(res.data.rows[i]);
            }
            this.totalTherr = res.data.total;
            this.maleParagraphLoading = false;
            if (this.maleParagraphList.length > 0) {
              this.maleParagraph = true;
            } else {
              this.maleParagraph = false;
            }
            if (this.totalTherr > 5) {
              this.isActiveTwo = true;
            }
            this.filterCoverShowTwo = false;
          }
        });
    },
    autoSlide() {
      // 图片轮播函数
      this.timer = setInterval(() => {
        let l = this.DataList.imgPaths.length;
        if (this.index < l) {
          $(".imgbox").removeClass("imgbck");
          $(".imgbox")
            .eq(this.index)
            .addClass("imgbck");
          this.imgurl = this.DataList.imgPaths[this.index];
          this.index++;
        } else {
          $(".imgbox").removeClass("imgbck");
          $(".imgbox")
            .eq(0)
            .addClass("imgbck");
          this.imgurl = this.DataList.imgPaths[0];
          this.index = 1;
        }
      }, 3000); //每隔1.5S就切换一次图片
    },

    changeImg(index) {
      $(".imgbox").removeClass("imgbck");
      $(".imgbox")
        .eq(index)
        .addClass("imgbck");
      this.imgurl = this.DataList.imgPaths[index];
      this.index = index;
      //  this.autoSlide(); // 图片开始再次轮播
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style scope lang="scss">
.el-message {
  border-radius: 50px !important;
  min-width: 450px !important;
  height: 100px !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  font-size: 40px !important;
  justify-content: center;
}
.el-message p {
  font-size: 30px;
}
.el-message-box__btns {
  text-align: center !important;
  margin: 20px 0;
}
.el-message-box__headerbtn {
  font-size: 30px !important;
  top: 20px !important;
}
.el-message-box {
  width: 1024px !important;
  height: 335px !important;
}
.el-message-box__header {
  background: #fff2ea;
  height: 70px;
  padding: 0 !important;
}
.el-message-box__title {
  padding-top: 26px;
  margin-left: 70px;
  color: #010101;
  font-size: 30px;
}
.el-message-box__container {
  display: flex;
  justify-content: center;
  font-size: 24px !important;
  margin: 55px 0 55px 0;
}
.el-message-box__btns .el-button {
  width: 290px;
  height: 50px;
  padding: 0;
  border-radius: none;
  font-size: 24px;
}
.el-message-box__content {
  padding: 0 !important;
}
.el-message-box__status + .el-message-box__message {
  font-size: 36px !important;
}
.el-message-box__btns .el-button span {
  width: 285px;
  background: #333333;
  display: inline-block;
  height: 49px;
  line-height: 49px;
  color: #fff;
  border-radius: none;
}
.el-message-box__btns .el-button span:hover {
  width: 290px;
  border-radius: none;
}
.el-message-box__btns .el-button--primary span {
  width: 285px;
  background: #ec9368;
  display: inline-block;
  height: 49px;
  line-height: 49px;
  border-radius: none;
}
.el-button--primary {
  background: #fff !important;
  border-color: #ec9368 !important;
  border-radius: none !important;
}
.el-message-box__status {
  position: relative !important;
  top: 0 !important;
  transform: none !important;
}
.el-message-box__status + .el-message-box__message {
  padding-left: 13px !important;
}
.order .imgbck {
  width: 184px;
  height: 184px;
  display: inline-block;
  border: 1px solid #ec9368;
  z-index: 999;
}
.order .imgbox {
  width: 184px;
  height: 184px;
  display: inline-block;
  overflow: hidden;
}
.imgbox:nth-child(1) {
  margin-right: 10px;
}
.imgbox:nth-child(2) {
  margin-right: 10px;
}
.productNameClass {
  font-size: 24px;
  color: #ec9368;
}
.styleNumberClass {
  width: 150px;
  margin-top: 15px;
  font-size: 22px;
  color: #000;
}
.box_goumai {
  margin-left: 52px;
  width: 572px;
}
.loversBox {
  width: 100%;
  .loversBoxChild {
    display: flex;
    text-align: center;
    min-height: 46px;
    line-height: 46px;
    border: 1px solid #ec9368;
    border-top: none;
    .el-input__inner {
      border: none;
      text-align: center;
    }
    .el-input__inner:focus,
    .el-input__inner:hover {
      border: none !important;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      background: #fff !important;
      border: none;
      font-size: 18px;
    }
    .el-textarea__inner {
      border: none !important;
    }
    .loversBoxChild_title {
      width: 30%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #ec9368;
    }
    .femaleClass {
      width: 35%;
      border-right: 1px solid #ec9368;
      position: relative;
      img {
        width: 28px;
        height: 28px;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
    .maleClass {
      width: 35%;
      position: relative;
      img {
        width: 28px;
        height: 28px;
        position: absolute;
        bottom: 0;
        right: 0;
      }
    }
  }
  .loversBoxChild:first-child {
    border-top: 1px solid #ec9368;
  }
}
.box {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  margin-top: 28px;
}
.order_style {
  font-size: 18px;
  display: flex;
  flex-wrap: wrap-reverse;
  align-items: center;
  justify-content: space-between;
}
.order_style_child {
  width: 130px;
  height: 45px;
  display: flex;
  font-size: 16px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap-reverse;
  box-sizing: content-box;
  border: 1px solid #ee9c75;
  margin-right: 27px;
  position: relative;
  cursor: pointer;
}
.order_style_child img {
  width: 24px;
  height: 24px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.order_style_title {
  margin-right: 5px;
  height: 45px;
  width: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap-reverse;
}
.priceClass {
  color: #ec9368;
}
.el-divider--horizontal {
  margin: 10px 0 !important;
}
.displayClass {
  display: flex;
  width: 477px;
}
.selectBorder .el-select {
  width: 100%;
}
.selectBorder .el-select .el-input__inner {
  border: none;

  text-align: right;
  color: #ec9368;
  font-size: 18px;
}
.selectBorder {
  width: 440px;
  text-align: right;
  .el-input__inner:focus,
  .el-input__inner:hover {
    border: none !important;
  }
}
.el-select-dropdown__item {
  min-width: 80px;
  padding: 0 !important;
  display: inline-block !important;
  text-align: center;
  border: 1px solid #d3d3d3 !important;
  color: #000 !important;
  margin-right: 13px;
  span {
    margin: 0 5px;
  }
}
.el-select-dropdown__list {
  padding: 10px !important;
  padding-right: 0 !important;
}
// .el-popper[x-placement^="bottom"] {
//   width: 465px !important;
// }
.el-select-dropdown__item.selected {
  background: #fff2ea !important;
  color: #000 !important;
  font-weight: normal !important;
  border: 1px solid #ee9c75 !important;
}
.el-select-dropdown {
  border: 1px solid #ec9368 !important;
}
.remarksClass {
  .remarksClass_title {
    margin-bottom: 8px;
    width: 120px;
    display: inline-block;
    text-align: center;
  }
  .remarksClass_text {
    display: inline-block;
    width: 440px;
    word-break: break-all;
  }
  .el-textarea__inner {
    background: #f3f3f3;
    color: #999;
  }
  .el-textarea__inner:focus {
    border: 1px solid #dcdfe6;
  }
}
.numberClass
  .el-input-number__decrease:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)
  ~ .el-input
  .el-input__inner:not(.is-disabled) {
  border-color: #ec9368 !important;
}
.soptClass {
  width: 1200px;
  margin: 0 auto;
  margin-top: 20px;
  box-sizing: content-box;
  border: 1px solid rgb(236, 147, 104);
  .soptClass_head {
    width: 100%;
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #f4c7b1;
    font-size: 18px;
    color: #000;
    border-bottom: 1px solid #ec9368;
  }
  .context_box {
    .context_head {
      display: flex;
      border-bottom: 1px solid #ec9368;
      font-size: 16px;
      color: #000000;
    }
    .active {
      padding-right: 17px;
    }
    .activeTwo {
      padding-right: 17px;
    }
    .context_head_textuer {
      width: 58px;
      display: flex;
      justify-content: center;
      min-height: 40px;
      align-items: center;
      border-right: 1px solid #ec9368;
      box-sizing: content-box;
    }
    .context_head_name {
      min-height: 40px;
      width: 67px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: content-box;
      border-right: 1px solid #ec9368;
      .el-checkbox__inner {
        width: 32px !important;
        height: 32px !important;
      }
      .el-checkbox__input.is-checked .el-checkbox__inner,
      .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #ec9368 !important;
        border-color: #ec9368 !important;
      }
      .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #dcdfe6 !important;
      }
      .el-checkbox__inner::after {
        height: 18px !important;
        left: 12px !important;
        top: 3px !important;
        width: 7px !important;
      }
      .el-checkbox__inner:hover {
        border-color: #ec9368;
      }
    }
    .context_head_name:last-child {
      border-right: none;
    }
    .context_head_OneName {
      min-height: 40px;
      border-right: 1px solid #ec9368;
      width: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: content-box;
    }
    .list-item {
      display: flex;
      border-bottom: 1px solid #ec9368;
    }
    .list-item:last-child {
      border-bottom: none;
    }
  }
}
</style>
<style>
.el-popper {
  height: auto !important;
}
.el-popper {
  width: 100px;
  height: 200px;
  overflow: auto;
}
* {
  margin: 0;
  padding: 0;
}
.banner {
  width: 576px;
  height: 186px;
  margin: 0 auto;
  margin-top: 20px;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}
.box_detail_input .el-input-number {
  height: 46px !important;
  line-height: 46px !important;
}
.banner .slide {
  width: 576px;
  height: 200px;
  position: absolute;
  overflow: hidden;
  /* left: 0;
    top: 0; */
}
.banner .slide img {
  width: 186px;
  height: 186px;
  box-sizing: border-box;
  /* padding: 10px; */
  line-height: 186px;
  text-align: center;
  float: left;
  font-size: 72px;
  color: white;
}
.banner .slide .a {
  background-color: black;
}
.banner .slide .b {
  background-color: pink;
}
.banner .slide .c {
  background-color: purple;
}
.el-button--primary {
  background: #fff !important;
  border-color: #ec9368 !important;
  border-radius: none !important;
}
.onebottom .el-button:hover {
  width: 572px !important;
}
.onebottom .el-button {
  border: none !important;
  border-radius: 0;
}
.onebottom {
  border: 1px solid #ec9368;
  margin-bottom: 26px;
  margin-top: 26px;
}
[v-cloak] {
  display: none;
}
.noMore {
  background: #dcdfe6;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #ec9368;
}
.lodClass {
  background: #ec9368;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #ec9368;
}
</style>
